import ScrollReveal from './ScrollReveal';

const audiences = [
  { icon: 'ri-store-2-line', label: 'Dueños de negocio' },
  { icon: 'ri-rocket-2-line', label: 'Emprendedores' },
  { icon: 'ri-user-star-line', label: 'Freelancers' },
  { icon: 'ri-building-2-line', label: 'Agencias de marketing' },
  { icon: 'ri-group-line', label: 'Community Managers' },
  { icon: 'ri-camera-lens-line', label: 'Creadores de contenido' },
  { icon: 'ri-megaphone-line', label: 'Personas iniciando en Meta Ads' },
];

export default function TargetAudience() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F8FA]">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-14">
            <span className="inline-block text-xs font-semibold tracking-wider uppercase text-[#C8A24A] mb-3">
              Audiencia
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#111111]">
              ¿Para quién es este taller?
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 max-w-[1000px] mx-auto">
          {audiences.map((item, idx) => (
            <ScrollReveal key={item.label} delay={idx * 70}>
              <div className="group bg-white rounded-2xl p-5 md:p-6 border border-gray-100 text-center hover:border-[#E53935]/15 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(0,0,0,0.05)] cursor-default">
                <div className="w-12 h-12 rounded-xl bg-[#F7F8FA] group-hover:bg-[#E53935]/5 flex items-center justify-center mx-auto mb-3 transition-colors duration-300">
                  <i className={`${item.icon} text-[#E53935] text-xl`}></i>
                </div>
                <span className="text-sm font-medium text-[#333333] leading-snug">{item.label}</span>
              </div>
            </ScrollReveal>
          ))}
        </div>

        {/* Extra audience note */}
        <ScrollReveal delay={400}>
          <div className="mt-10 max-w-[700px] mx-auto">
            <div className="bg-white rounded-2xl p-6 border border-[#C8A24A]/15 flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-[#C8A24A]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-lightbulb-line text-[#C8A24A] text-lg"></i>
              </div>
              <div>
                <p className="text-sm text-[#444444] leading-relaxed">
                  <strong className="text-[#111111]">No necesitas experiencia previa.</strong> Este taller está diseñado tanto para principiantes como para profesionales que quieren incorporar IA en su flujo de trabajo.
                </p>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}